import { I18nextProvider } from "react-i18next";
import { I18N_CONFIG } from "@/app/configs/i18n-config";

export function TranslateProvider(props: React.PropsWithChildren) {
  return <I18nextProvider i18n={I18N_CONFIG}>{props.children}</I18nextProvider>;
}
